import { render, staticRenderFns } from "./ZoomControlsV2.vue?vue&type=template&id=f468965e&scoped=true&"
import script from "./ZoomControlsV2.vue?vue&type=script&lang=js&"
export * from "./ZoomControlsV2.vue?vue&type=script&lang=js&"
import style0 from "./ZoomControlsV2.vue?vue&type=style&index=0&id=f468965e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f468965e",
  null
  
)

export default component.exports